/* eslint-disable no-console */
import { put, cancelled } from 'redux-saga/effects';
import { createAction } from 'redux-actions';
import { propOr, path, applySpec, pipe, map, prop, filter, head, not, isEmpty } from 'ramda';

import dictionary from 'utils/dictionary.json';

import { SUCCESS, ERROR, LOADING, META, TASK_ID } from './consts';
import { setLoading, setSuccess, setError, setCancel } from './actions';

export const withAlert = (saga) =>
  function* wrapper(action) {
    const id = path([META, TASK_ID], action);
    const type = prop('type', action);

    yield put(setLoading(id));

    try {
      const data = yield saga(action);
      const success = data?.success;
      const error = data?.error;

      if (error && process.env.NODE_ENV === 'development') console.error('sagaHandlerError: ', { type, id, error });

      yield error ? put(setError({ id, error })) : put(setSuccess({ id, success }));
    } catch (error) {
      if (error && process.env.NODE_ENV === 'development') console.error('sagaHandlerError: ', { type, id, error });

      yield put(setError({ id, error: propOr(dictionary.defaultError, 'message')(error) }));
    } finally {
      const isCancelled = yield cancelled();

      if (isCancelled) yield put(setCancel(id));
    }
  };

let counter = 0;
export const createAlertAction = (type) =>
  createAction(
    type,
    ($) => $,
    () => {
      counter += 1;
      return { [TASK_ID]: counter };
    }
  );

export const mergeAlerts = (alerts) =>
  applySpec({
    [ERROR]: pipe(map(prop(ERROR)), filter(Boolean), head),
    [SUCCESS]: pipe(map(prop(SUCCESS)), filter(not), isEmpty),
    [LOADING]: pipe(map(prop(LOADING)), filter(Boolean), head),
  })(alerts);
